'use client';

import { recordImpression } from '@/actions/public/server.actions';
import FollowUserButton from '@/components/Buttons/FollowUserButton';
import useUserProfile from '@/hooks/useUserProfile';
import ShareButton from '@components/ShareButton';
import Button from '@ui/Button';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

function HeaderButtons({ userProfile, currentUser = null }) {
  const router = useRouter();

  const user = useUserProfile();

  let recordShareClickPayload = {
    type: 'individual_public_profile_page',
    userId: userProfile.id,
    shareClick: {
      userId: currentUser?.id,
      activeCommunityId: currentUser?.activeCommunity?.id,
      location: currentUser?.location,
    },
  };

  // useEffect(() => {
  //   const handleRecordImpression = () => {
  //     const payload = {
  //       type: 'individual_public_profile_page',
  //       userId: userProfile.id,
  //       impression: {
  //         userId: user?.id,
  //         activeCommunityId: user?.activeCommunity?.id,
  //         location: user?.location,
  //       },
  //     };
  //     recordImpression(payload);
  //   };

  //   const timer = setTimeout(() => {
  //     if (user.id > 0) {
  //       handleRecordImpression();
  //     }
  //   }, 5000);

  //   return () => clearTimeout(timer);
  // }, [user]);

  const handleNavigate = () => {
    router.push('/profile/me');
  };

  const isCurrentUser = currentUser?.id === userProfile?.id;

  return (
    <div className="flex gap-2 self-end px-6 lg:self-start lg:pl-0 lg:pr-4">
      {/* {isCurrentUser ? (
        <Button variant="filled" color="primary" onClick={handleNavigate}>
          Exit View
        </Button>
      ) : (
        <FollowUserButton
          user={userProfile}
          viewer={currentUser}
          disabled={!currentUser}
        />
      )} */}
      <FollowUserButton
        user={userProfile}
        viewer={currentUser}
        disabled={!currentUser}
      />
      <ShareButton variant="text" recordPayload={recordShareClickPayload} />
    </div>
  );
}

export default HeaderButtons;
